import { useTranslation } from 'react-i18next';
import { KizenTypography } from '__app/typography';
import { useEmailFromDomainEnabledEntitlement } from '__hooks/useEmailFromDomainEnabledEntitlement';
import { InfoWrapper, TextWrapper } from './styles';

type IntegratedEmailWarningProps = {
  externalAccount: boolean;
  noMarginBottom?: boolean;
};

export const IntegratedEmailWarning = (props: IntegratedEmailWarningProps) => {
  const { externalAccount, noMarginBottom } = props;
  const { t } = useTranslation();
  const emailFromDomainEnabled = useEmailFromDomainEnabledEntitlement();

  return !emailFromDomainEnabled || externalAccount ? (
    <InfoWrapper noMarginBottom={noMarginBottom}>
      <TextWrapper>
        <KizenTypography as="span">
          {t(
            'Based on your email account type you have a daily quota of emails you can send via the selected integrated inbox.'
          )}
        </KizenTypography>
      </TextWrapper>
    </InfoWrapper>
  ) : null;
};
